import { colorCategories, swatches } from "@/mocks/colors";

type Props = {
  onPick: (categoryId: string) => void;
};

export default function CategoryBoard({ onPick }: Props) {
  const gotoAtlas = (categoryId: string) => {
    onPick(categoryId);
    document.getElementById("atlas")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="series" className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <p className="flex items-center gap-3 text-accent-700 text-xs tracking-display uppercase">
              <span className="font-number text-lg">01</span>
              <span className="inline-block w-8 h-px bg-accent-500" />
              色系分类目录
            </p>
            <h2 className="mt-4 font-serif text-foreground-950 text-2xl md:text-[32px] font-semibold">
              六条黑料色脉络，先选你需要的
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-xs hidden md:block">
            从极黑到暖黑，按底调与明度切开六条脉络，点任意色系直达对应色卡。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {colorCategories.map((c) => {
            const count = swatches.filter((s) => s.categoryId === c.id).length;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => gotoAtlas(c.id)}
                className="group cursor-pointer rounded-lg border border-background-200 bg-background-50 overflow-hidden text-left hover:-translate-y-0.5 hover:border-accent-300 transition-all"
              >
                <div className="h-24 md:h-28 relative" style={{ backgroundColor: c.sample }}>
                  <span className="absolute top-3 left-3 font-number text-background-50/90 text-lg tracking-wider">
                    {c.seq}
                  </span>
                  <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent" />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-serif text-foreground-950 text-base md:text-lg">{c.name}</h3>
                    <span className="text-[11px] text-background-50 px-2 py-0.5 rounded-full bg-primary-800">
                      {count} 色号
                    </span>
                  </div>
                  <p className="mt-1 text-foreground-500 text-[10px] tracking-display uppercase font-medium">{c.en}</p>
                  <p className="mt-3 text-[13px] leading-6 text-foreground-600">{c.tagline}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-accent-700 text-[13px] font-medium">
                    查看该色系
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}